import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { APP_INITIALIZER, ErrorHandler } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { ControlsModule } from './controls/controls.module';
import { SharedModule } from './shared/shared.module';
import { FeaturesModule } from './features/features.module';

import { AppComponent } from './app.component';
import * as Sentry from "@sentry/angular";
import { Router } from '@angular/router';
import { provideTablerIcons } from 'angular-tabler-icons';
import * as TablerIcons from "angular-tabler-icons/icons";
import { QuillModule } from 'ngx-quill';
import { SubscriptionViewComponent } from './features/subscription-view/subscription-view.component';
import { TermsComponent } from './features/terms/terms.component';
import { environment } from '../environments/environment';
import { initializeApp } from 'firebase/app';
import { provideFirebaseApp } from '@angular/fire/app';
import { getAuth } from 'firebase/auth';
import { provideAuth } from '@angular/fire/auth';
/*import { SocialAuthServiceConfig, SocialLoginModule } from 'angularx-social-login';
import {
  GoogleLoginProvider
} from 'angularx-social-login';*/

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        FormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        AppRoutingModule,
        CoreModule,
        ControlsModule,
        SharedModule,
        FeaturesModule,
        SubscriptionViewComponent,
        TermsComponent,
        QuillModule.forRoot(),
        // SocialLoginModule
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [Sentry.TraceService],
            multi: true,
        },
        /*{
            provide: 'SocialAuthServiceConfig',
            useValue: {
              autoLogin: false,
              providers: [
                {
                  id: GoogleLoginProvider.PROVIDER_ID,
                  provider: new GoogleLoginProvider(
                    'clientId'
                  )
                }
              ],
            } as SocialAuthServiceConfig,
        },*/
        provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
        provideAuth(() => getAuth()),
        provideTablerIcons(TablerIcons),
    ]
})
export class AppModule { }
